import { EntityQRCodeParametersSimpleView } from '../types';

// A code with no record of its own is opened by its keyword, and saving it there is what gives it one.
export function qrCodeEditPath(
  qrCode: Pick<EntityQRCodeParametersSimpleView, 'id' | 'keywordId' | 'companyId'>,
): string {
  const params = new URLSearchParams(
    qrCode.id != null
      ? { companyId: qrCode.companyId, id: qrCode.id }
      : { companyId: qrCode.companyId, keywordId: qrCode.keywordId ?? '' },
  );
  return `/qr-codes/edit?${params.toString()}`;
}
